import { render } from "./speakers.vue?vue&type=template&id=0aef554e&scoped=true"
import script from "./speakers.vue?vue&type=script&lang=js"
export * from "./speakers.vue?vue&type=script&lang=js"

import "./speakers.vue?vue&type=style&index=0&id=0aef554e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0aef554e"

export default script